import { lightFormat } from "date-fns";

export const formatReleaseTime = (releaseTime: string) =>
  lightFormat(new Date(Number(releaseTime)), "dd.MM.yyyy HH:mm:ss");
